import { instance } from "libs/api";

export interface ComputePackMinBuyingPriceBody {
  slots: Array<{ variantIds: string[] }>;
}

export interface ComputePackMinBuyingPriceResponse {
  minBuyingPriceCombination: number;
}

export const requestComputePackMinBuyingPrice = async (
  body: ComputePackMinBuyingPriceBody
): Promise<ComputePackMinBuyingPriceResponse> => {
  return await instance.post(
    `admin/packs/min-buying-price-combination`,
    body
  );
};
